import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { trackClick } from '../utils/telemetry';
import './AftermathBanner.css';

const AftermathBanner = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'pk-aftermath-banner-style';
    style.textContent = '.App { padding-top: 48px !important; } .header { top: 48px !important; }';
    document.head.appendChild(style);
    return () => {
      const s = document.getElementById('pk-aftermath-banner-style');
      if (s) s.remove();
    };
  }, []);

  const handleClick = () => {
    trackClick('/aftermath-banner');
    window.open('https://hegxib.me/contact', '_blank');
  };

  return createPortal(
    <div className="pk-aftermath-banner" dir="rtl" onClick={handleClick}>
      <span className="pk-aftermath-text">
        فرصة استثمارية — تواصل مع المطور واشترِ هذا الموقع الإلكتروني
      </span>
    </div>,
    document.body
  );
};

export default AftermathBanner;
